import {
  createCrudActions,
  createCrudActionTypes,
  createCrudMutation,
  createCrudState,
  createExportActions,
  createExportActionTypes,
  createExportMutation,
  createExportState
} from 'vuex-module-generator';

import { result } from 'lodash';
import normalizeVisit from '@/modules/visit/normalizeVisit';
import { fetchAuditor, fetchAuditorVisits } from './api';

export const auditorTypes = {
  ...createCrudActionTypes('TEAM_GROUP'),
  ...createExportActionTypes('TEAM_GROUP')
};

export const Auditorstate = () => ({
  list: createCrudState().list,
  active: createCrudState().active,
  ...createExportState()
});

export const mutations = {
  ...createCrudMutation(auditorTypes),
  ...createExportMutation(auditorTypes)
};

export const actions = createCrudActions(auditorTypes);
export const exportAction = createExportActions(auditorTypes);

export default {
  state: Auditorstate,
  mutations,
  actions: {
    cleanActiveAuditor({ commit }) {
      commit(actions.clean.active());
    },
    async fetchAuditor({ commit }, { projectId, auditorId }) {
      commit(actions.show.request());
      try {
        const res = await fetchAuditor(projectId, auditorId);
        commit(actions.show.success(res.data));

        return Promise.resolve(res);
      } catch (error) {
        commit(actions.show.failure(error));

        return Promise.reject(error);
      }
    },
    cleanAuditorVisitList({ commit }) {
      commit(actions.clean.list());
    },
    async fetchAuditorVisits({ commit }, { projectId, auditorId, paginationData }) {
      commit(actions.index.request());
      try {
        const res = await fetchAuditorVisits(projectId, auditorId, paginationData);

        const list = result(res, 'data.data', []);
        const normalizedList = list.map(normalizeVisit);

        commit(actions.index.success({
          ...res.data,
          data: normalizedList
        }));

        return res.data;
      } catch (error) {
        commit(actions.index.failure(error));

        return Promise.reject(error);
      }
    }
  }
};
